module.exports = __webpack_public_path__ + "img/Chicken_Caesar.72b3b8c0.jpg";